import SEO from "../../../../src/components/SEO";
import BrandMovie from "../../../../src/components/BrandMovie";
import * as style from "../../../../src/pages/brand/ameba-brand/vision-and-mission.css";
import * as React from 'react';
export default {
  SEO,
  BrandMovie,
  style,
  React
};